import DataStore from '../../stores/DataStore';
import { ModelDataUpdate } from '../../Events';
import { Report } from '../../model/Report';
import { defined, evaluate } from '../../utility/Control';
import StringFormatter from '../../utility/StringFormatter';
import AlertRuncomGenerator from '../../utility/AlertRuncomGenerator';
import Swal from 'sweetalert2';
import { HousingValue } from '../../model/HousingValue';
import { CadastreHousingValueConveyance } from '../../model/CadastreHousingValueConveyance';

const tagProperties: string[] = [
  'address',
  'postalCode',
  'postalPlace',
  'estimatedHousingValue',
  'estimatedHousingValuePerSquareMeter',
  'sumPledge',
  'message',
  'presentable',
  'referencedCadastre',
  'purchasePrice',
  'dateRegistered'
];

export function init(tag: any): void {
  const onModelDataUpdate = () => {
    map(DataStore.getReport(), tag);
    tag.update();
  };
  tag.on('mount', () => {
    DataStore.addListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.on('unmount', () => {
    DataStore.removeListener(ModelDataUpdate, onModelDataUpdate);
  });
}

function map(report: Report, tag: any): void {
  tagProperties.forEach((tagProperty: string) => {
    tag[tagProperty] = undefined;
  });
  const alertRc = AlertRuncomGenerator.generate(report.info);
  if (defined(alertRc)) {
    Swal.fire(alertRc.settings, alertRc.onConfirm);
  }
  const presentable = defined(report) && report.isPresentable;
  tag.presentable = presentable;
  if (!presentable) {
    return;
  }
  if (defined(report.cadastre)) {
    tag.address = StringFormatter.formatCadastreKey(report.cadastre.key);
    const address = report.cadastre.address;
    if (defined(address)) {
      if (address.streetAddress) {
        tag.address = address.streetAddress;
      }
      tag.postalCode = address.postalCode;
      tag.postalPlace = address.postalPlace;
    }
  }
  const housingValue: HousingValue = report.housingValue;
  if (defined(housingValue)) {
    if (defined(housingValue.calculatedValue)) {
      tag.estimatedHousingValue = StringFormatter.formatMonetaryAmount(housingValue.calculatedValue.toString());
    }
    if (defined(housingValue.pricePerSquareMeter)) {
      tag.estimatedHousingValuePerSquareMeter = StringFormatter.formatMonetaryAmount(
        housingValue.pricePerSquareMeter.toString()
      );
    }
  }
  if (defined(report.sumPledge)) {
    tag.sumPledge = StringFormatter.formatMonetaryAmount(report.sumPledge.toString());
  }
  const conveyance: CadastreHousingValueConveyance = evaluate(report, 'housingValue.mostRecentFreeMarketConveyance');
  if (defined(conveyance)) {
    tag.purchasePrice = StringFormatter.formatMonetaryAmount(conveyance.purchasePrice.toString());
    tag.dateRegistered = conveyance.dateRegistered;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/housingValueDisplay/HousingValueDisplayHeaderMapper.ts
 **/